var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7917 15.1667H15.9358L15.6325 14.8742C16.6942 13.6392 17.3333 12.0358 17.3333 10.2917C17.3333 6.4025 14.1808 3.25 10.2917 3.25C6.4025 3.25 3.25 6.4025 3.25 10.2917C3.25 14.1808 6.4025 17.3333 10.2917 17.3333C12.0358 17.3333 13.6392 16.6942 14.8742 15.6325L15.1667 15.9358V16.7917L20.5833 22.1975L22.1975 20.5833L16.7917 15.1667ZM10.2917 15.1667C7.59417 15.1667 5.41667 12.9892 5.41667 10.2917C5.41667 7.59417 7.59417 5.41667 10.2917 5.41667C12.9892 5.41667 15.1667 7.59417 15.1667 10.2917C15.1667 12.9892 12.9892 15.1667 10.2917 15.1667Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03f2f4b5d42368d57b708f0b720198ca.svg";
export { ForwardRef as ReactComponent };